/**
* In this file we handel to show the measurement details into Line chart with popup screen
**/
import { Modal,Button } from 'react-bootstrap';
//import { Chart as ChartJS, CategoryScale } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useEffect,useState } from 'react';
import percentilesHeight from './../../dataset/percentilesHeight.json';
import percentilesWeight from './../../dataset/percentilesWeight.json';
import { getLabel } from './../../services/UtilsService';
import ApiService from './../../services/ApiService';
import { postAnalytics } from './../../services/ReusabilityService';
import constantVariables from './../../dataset/constantVariables.json';
import { useTranslation } from 'react-i18next';

//ChartJS.register(CategoryScale);
function MeasurementChart(props) {
	//Intial state declaration
	const [chartData,setChartData]=useState([]);
	const [percentileLatest,setLatest]=useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();
	
	//Modal intialize function
	useEffect(()=>{
		const fetchData = async () => {
		setIsLoading(true); 
		try {
			console.log("prop",props);
			var response=await ApiService.listMemberMeasurement({id:props.data.member,category:props.data.chartName});	
			if(response.status===200){
				var result=response.data.items;
				sessionStorage.setItem('screenStartTime', new Date());
			  if(result.length !==0){
				// Remove duplicates based on age_range and relevant field (height or weight)
				const uniqueItems = result.reduce((acc, item) => {
					// Determine the field to filter (height or weight)
					const keyField = props.data.chartName === 'Height' ? 'height' : 'weight';
					const key = `${item.age_range}-${item[keyField]}`; // Combine age_range and relevant field
					if (!acc[key]) {
						acc[key] = item; // Add only the first occurrence of each unique combination
					}
					return acc;
				}, {});
				// Convert the object back to an array
				const filteredItems = Object.values(uniqueItems);
				var percentilesList=[];
				
				//To load dynamicaly percentiles list
				if(props.data.chartName==='Height'){
				  percentilesList=props.data.gender===0?percentilesHeight.boy:percentilesHeight.girl;
				}else{
				  percentilesList=props.data.gender===0?percentilesWeight.boy:percentilesWeight.girl;
				}
				
				var data=filterMeasurement(filteredItems,props?.data.chartName);
				
				
                //To load the percentile chart dataset
                var dataSet=[
					{
					  label:"",
					  data:  data.map((item) => Array.isArray(item) ? undefined : item),
					  backgroundColor: "black",
					  borderColor: "black",
					  borderWidth: 0
					},
					{
					  label:`3${t('common.tth')}`,
					  data: percentilesList.map(i=>i.percentile1),
					  backgroundColor: "#f56c2c",
					  borderColor: "#f56c2c",
					  cubicInterpolationMode: 'monotone',
					  pointRadius: 0
					},
					{
					  label:`15${t('common.tth')}`,
					  data: percentilesList.map(i=>i.percentile2),
					  backgroundColor: "#fca232",
					  borderColor: "#fca232",
					  cubicInterpolationMode: 'monotone',
					  pointRadius: 0
					},
					{
					  label:`50${t('common.tth')}`,
					  data: percentilesList.map(i=>i.percentile3),
					  backgroundColor: "#70e08a",
					  borderColor: "#70e08a",
					  cubicInterpolationMode: 'monotone',
					  pointRadius: 0
					},
					{
					  label:`85${t('common.tth')}`,
					  data: percentilesList.map(i=>i.percentile4),
					  backgroundColor: "#fca232",
					  borderColor: "#fca232",
					  cubicInterpolationMode: 'monotone',
					  pointRadius: 0
					},
					{
					  label:`97${t('common.tth')}`,
					  data: percentilesList.map(i=>i.percentile5),
					  backgroundColor: "#f56c2c",
					  borderColor: "#f56c2c",
					  cubicInterpolationMode: 'monotone',
					  pointRadius: 0
					},
			
		       ];
				
				//To plot the multiple value in single x axis
				data.map((item) => Array.isArray(item) ? item : undefined).map((x, i) => {
					if(x){
						x.filter(y => {
							var a = [];
							a[i] = y;
							dataSet.unshift({
								label: "",
								data: a,
								backgroundColor: "black",
								borderColor: "black",
								borderWidth: 0
							});
							return true; 
						});
					}
					 return true; 
				});
				setChartData(dataSet);
				//To set the last value of every percentile level
				var latest=[
				{value:percentilesList[percentilesList.length-1].percentile1,label:`3${t('common.tth')}`},
				{value:percentilesList[percentilesList.length-1].percentile2,label:`15${t('common.tth')}`},
				{value:percentilesList[percentilesList.length-1].percentile3,label:`50${t('common.tth')}`},
				{value:percentilesList[percentilesList.length-1].percentile4,label:`85${t('common.tth')}`},
				{value:percentilesList[percentilesList.length-1].percentile5,label:`97${t('common.tth')}`}
				];
				setLatest(latest);
			  }
			}
		}catch (error) {
				console.error('Error fetching member appointment:', error);
		} finally {
			setIsLoading(false); 
		}
		};
		fetchData();		
		
		//To post the Analytics data
		return async()=>{
			var reqData={};
			reqData.parent = props.data.parent;
			reqData.member = props.data.member;
			reqData.module = 'measurement';
			reqData.type = props.data.chartName;
			postAnalytics(reqData);
		}
		
	},[props]);


	/** 
	* To find the measurement array list 
	* @arr pass the all char details in array 
	* @name pass the chart category name
	**/
	const filterMeasurement = (arr, name) => {
		 var outputArray = [];
		  arr.forEach(({ age_range, height,weight }) => {
			var module = name==='Height'?height:weight;
			  
			if (outputArray[age_range]) {
			  if (Array.isArray(outputArray[age_range])) {
				outputArray[age_range].push(module);
			  } else {
				outputArray[age_range] = [outputArray[age_range], module];
			  }
			} else {
			  outputArray[age_range] = module;
			}
		  });

		  return outputArray;
	};
	
	
	//To set the data for chart
	const data = {
	  labels: [`0 ${t('common.week')}`,`1 ${t('common.week')}`, `2 ${t('common.weeks')}`, `3 ${t('common.weeks')}`, `4 ${t('common.weeks')}`, `5 ${t('common.weeks')}`, `6 ${t('common.weeks')}`, `7 ${t('common.weeks')}`, `8 ${t('common.weeks')}`, `9 ${t('common.weeks')}`, `10 ${t('common.weeks')}` , `11 ${t('common.weeks')}`, `12 ${t('common.weeks')}` ,`13 ${t('common.weeks')}` , `4 ${t('common.mons')}`, `5 ${t('common.mons')}`,`6 ${t('common.mons')}`, `7 ${t('common.mons')}`, `8 ${t('common.mons')}`, `9 ${t('common.mons')}`, `10 ${t('common.mons')}` , `11 ${t('common.mons')}`, `1 ${t('common.yr')}`, `1 ${t('common.mon')}`, `2 ${t('common.mons')}`, `3 ${t('common.mons')}`, `4 ${t('common.mons')}`, `5 ${t('common.mons')}`, `6 ${t('common.mons')}`, `7 ${t('common.mons')}`, `8 ${t('common.mons')}`, `9 ${t('common.mons')}`, `10 ${t('common.mons')}` , `11 ${t('common.mons')}`, `2 ${t('common.yrs')}`, `2 ${t('common.mons')}`, `4 ${t('common.mons')}`, `6 ${t('common.mons')}`, `8 ${t('common.mons')}`, `10 ${t('common.mons')}`, `3 ${t('common.yrs')}`, `2 ${t('common.mons')}`, `4 ${t('common.mons')}`, `6 ${t('common.mons')}`, `8 ${t('common.mons')}` , `10 ${t('common.mons')}`, `4 ${t('common.yrs')}`, `2 ${t('common.mons')}`, `4 ${t('common.mons')}`, `6 ${t('common.mons')}`, `8 ${t('common.mons')}` , `10 ${t('common.mons')}`, `5 ${t('common.yrs')}`, ""],
	  datasets: chartData
	};
	
	
	//To define the chart options 
	const options = {
	   scales: {
		//To display the x-axis label
		x: {
			ticks: {
			//maxRotation: 0,
			autoSkip: false, // Prevent automatic skipping of labels
			},
		  title: { //x axis title
			display: true,
			text: t('common.monthsAndYears'),
			color:`${role === 4 ? '#16C4AE' : '#00c4ef'}`,
			font: {
			  weight: 'bold', 
			  size: 14
			}
		  },
		},
		//To display the left side label
		y: {
			position: 'left',
		    title: { //y axis title
				display: true,
				text: props?.data.chartName === 'Height'
					? t('common.lengthOrHeight')
					: t('common.weightKg'),
				color:`${role === 4 ? '#16C4AE' : '#00c4ef'}`,
				font: {
				  weight: 'bold', 
				  size: 14
				}
		  	},
		  	// Dynamically adjust the y-axis max value
			ticks: {
				// Calculate and add one more step to the max value dynamically
				callback: function(value, index, values) {
					return value;
				}
			},
			// Dynamically set the y-axis max based on data
			afterDataLimits: (scale) => {
				const maxValue = scale.max;
				const minValue = scale.min;
				const range = maxValue - minValue;
	
				// Dynamically calculate the step size (e.g., 1/10th of the range)
				let stepSize = Math.ceil(range / 10);
	
				// Round stepSize to nearest 10, 20, 50, etc. (optional for cleaner steps)
				if (stepSize < 10) {
					stepSize = 10; // Minimum step size of 10
				} else {
					stepSize = Math.ceil(stepSize / 10) * 10; // Round to nearest 10
				}
	
				// Set the new max value with an additional step
				scale.max = Math.ceil(maxValue / stepSize) * stepSize + stepSize;
				// Optionally, set the min value too if needed
				// scale.min = 0;
	
				// Apply the dynamically calculated stepSize to the y-axis
				scale.options.ticks.stepSize = stepSize;
			}
		},
        //To display the right side label
		y1: {
			 position: 'right',
			 type: 'linear',
			 grid: {
               display: false, // Hide gridlines for y1 axis
             },
             afterBuildTicks: (axis) => {
			  axis.ticks = percentileLatest;
			  axis.min = axis.chart.scales.y.min;
			  axis.max = axis.chart.scales.y.max;
			},			 
			 ticks: {
				// Customize the text on the right side here
				callback: function (value, index, values) {
					switch(index){
						case 0:
						return `3${t('common.tth')}`;
						case 1:
						return `15${t('common.tth')}`;
						case 2:
						return `50${t('common.tth')}`;
						case 3:
						return `85${t('common.tth')}`;
						case 4:
						return `97${t('common.tth')}`;
						default:
						return '';
					}
				},
				color: ['#f56c2c', '#fca232', '#70e08a', '#fca232', '#f56c2c']
			  },
        },
	  },
	  
	  plugins: {
		tooltip: {
		  mode: 'nearest',
          intersect: false,
		  callbacks: { //Custom tooltip
           title: (xDatapoint) => {
			  if(xDatapoint.length !==0){	
				var head = xDatapoint[0].dataset.label;
				var a=xDatapoint[0].label;
				var mons= getLabel(a); 
				var yrs;
				var value = xDatapoint[0].parsed.x;
				if (value < 22 ) {
					return head ? head + `${t('common.percentile')}\n${t('table.age')}  :` + mons : `${t('table.age')} :` + mons;
				} else {
					if (22<=value && value <=33){
						yrs=Math.floor(value/17);	
					}else if( 34<=value && value <=39){
						yrs=Math.floor(value/17);	
					}else if( 40<=value && value <=45){
						yrs=Math.floor(value/13);	
					}else if( 46<=value && value <=51){
						yrs=Math.floor(value/11);	
					}else if(value === 52 ){
						yrs=Math.floor(value/10);
					} else {
						yrs = '';
					}
					if (value === 22 || value === 40 || value === 46 || value === 34 || value === 52){
						return  head ? head + `${t('common.percentile')}\n${t('table.age')}  :` + mons : `${t('table.age')} :` + mons;
					} else{
						return head ? head+`${t('common.percentile')}\n${t('table.age')}  :`+yrs+` ${t('common.yr')} `+mons: `${t('table.age')} :` +yrs+` ${t('common.yr')} `+mons;
					}
					
				}	
							
			  }
		   	},
			label: (yDatapoint) => {
				const chartName = props?.data?.chartName?.toLowerCase();
				const value = yDatapoint?.raw ?? 'N/A'; // fallback if raw is undefined
				if (chartName === 'height') {
					return `${t('table.height')}: ${value}`;
				} else if (chartName === 'weight') {
					return `${t('table.weight')}: ${value}`;
				} 
			}
		    // label: (yDatapoint) => { return  props?.data.chartName+': '+yDatapoint.raw }
		  }
		 },
		legend: {
		  display: false,
		},
	  },
    };
	
	
	return (
		<Modal 
		show={props.data.measurement} 
		onHide={props.handleClose}  
		backdrop="static"
		keyboard={false}
		size={chartData && chartData.length !==0?"xl":"md"}
		aria-labelledby="contained-modal-title-vcenter"
		centered
		>
	    <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
		<Modal.Title><h5 className="modal-title text-capitalize" id="appointmentsModalLabel">{props.data.name}{t('common.possessive_suffix')}  {props?.data.chartName === "Weight" ? t('table.weight') : t('table.height')}</h5></Modal.Title>
		</Modal.Header>
		<Modal.Body>
		{/*import Line Module*/}
		{chartData && chartData.length !==0 ? <Line data={data} options={options}/>: !isLoading&&
		<h5 className="text-center">{t('common.noRecord')}</h5>}
		</Modal.Body>
		{/*Footer*/}
		<Modal.Footer>
			<Button variant="secondary" className={`btn btn-sm ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmPink'}`} onClick={props.handleClose}>
				{t('modal.close')}
			</Button>
		</Modal.Footer>
		</Modal>
	);
}

export default MeasurementChart;